export enum ColorVariable {
    // Primary
    primary = '--primaryColor',
    // primaryRGB = '--primaryRGB',
    primaryButton = '--primaryButton',

    // Secondary
    secondary = '--secondaryColor',

    // Font Color
    font = '--fontColor',
    fontTitle = '--fontTitleColor',
    dataHeader = '--dataHeader',
    data = '--data',
    errorFont = '--errorFont',
    inputPlaceHolderText = '--inputPlaceHolderText',
    instructionContainerFontColor = '--instructionContainerFontColor',
    materialFont = '--materialFont',
    hyperLinkColor = '--hyperLinkColor',
    headerButtonFontColor = '--headerButtonFontColor',
    formLabel = '--formLabel',
    devxlabelOne = '--devxlabelOne',
    devxlabelTwo = '--devxlabelTwo',

    // Background
    background = '--backgroundColor',
    inputBackground = '--inputBackground',
    errorBackground = '--errorBackground',
    loadingBackground = '--loadingBackground',
    contentContainerBackground = '--contentContainerBackground',
    contentHeaderNoteBackground = '--contentHeaderNoteBackground',
    checkboxSelectedBackground = '--checkboxSelectedBackground',
    checkboxUnselectedBackground = '--checkboxUnselectedBackground',
    payStubTotalBackground = '--payStubTotalBackground',
    materialFormDisabledbackground = '--materialFormDisabledbackground',
    childTableRowBackground = '--childTableRowBackground',
    childTableBackground = '--childTableBackground',
    headerFooterBackground = '--headerFooterBackground',
    headerSeperator = '--headerSeperator',
    headerBoxShadow = '--headerBoxShadow',
    subHeaderBackground = '--subHeaderBackground',

    // Button
    buttonMenuLinkHovered = '--buttonMenuLinkHovered',
    buttonRegisterFontReg = '--buttonRegisterFontReg',
    buttonRegisterFontHovered = '--buttonRegisterFontHovered',
    buttonRegisterHovered = '--buttonRegisterHovered',
    buttonPrimaryFontReg = '--buttonPrimaryFontReg',
    buttonPrimaryFontHovered = '--buttonPrimaryFontHovered',
    buttonPrimaryFontActive = '--buttonPrimaryFontActive',
    buttonPrimaryFontDisabled = '--buttonPrimaryFontDisabled',
    buttonPrimaryBackgroundReg = '--buttonPrimaryBackgroundReg',
    buttonPrimaryBackgroundHovered = '--buttonPrimaryBackgroundHovered',
    buttonPrimaryBackgroundActive = '--buttonPrimaryBackgroundActive',
    buttonPrimaryBackgroundDisabled = '--buttonPrimaryBackgroundDisabled',
    buttonSecondaryFontReg = '--buttonSecondaryFontReg',
    buttonSecondaryFontHovered = '--buttonSecondaryFontHovered',
    buttonSecondaryFontActive = '--buttonSecondaryFontActive',
    buttonSecondaryFontDisabled = '--buttonSecondaryFontDisabled',
    buttonSecondaryBackgroundHovered = '--buttonSecondaryBackgroundHovered',
    buttonSecondaryBackgroundActive = '--buttonSecondaryBackgroundActive',

    // Gradient
    gradient1 = '--gradient1',
    gradient2 = '--gradient2',
    gradient3 = '--gradient3',
    gradientOverlayRGB = '--gradientOverlayRGB',

    // Other
    border = '--border',
    radioButtonUnselected = '--radioButtonUnselected',
    radioButtonSelected = '--radioButtonSelected',
    toggleButtonSelected = '--toggleButtonSelected',
    materialFieldBorder = '--materialFieldBorder',
    appDividerContainer = '--appDividerContainer',
    materialFormDisabledFont = '--materialFormDisabledFont',
    materialFormDisabledBorder = '--materialFormDisabledBorder',
    tableBorder = '--tableBorder',
    footerBorderColor = '--footerBorderColor',
    dropdownIcon = '--dropdownIcon',
    selectionContentActive = '--selectionContentActive',

    // New Controls
    newControlEnabledBackground = '--newControlEnabledBackground',
    newControlEnabledBorder = '--newControlEnabledBorder',
    newControlEnabledUnselected = '--newControlEnabledUnselected',
    newControlEnabledSelected = '--newControlEnabledSelected',

    newControlDisabledBackground = '--newControlDisabledBackground',
    newControlDisabledBorder = '--newControlDisabledBorder',
    newControlDisabledUnselected = '--newControlDisabledUnselected',
    newControlDisabledSelected = '--newControlDisabledSelected',

    //In Page NavBar Icon Backgrounds
    navBarIconBlue = '--navBarIconBlue',
    navBarIconMint = '--navBarIconMint',
    navBarIconCoral = '--navBarIconCoral',
    navBarIconCyan = '--navBarIconCyan',
    navBarIconLavender = '--navBarIconLavender',
    navBarIconPeach = '--navBarIconPeach',
    navBarIconGray = '--navBarIconGray',

    toastSucces = '--toastSucces',
    toastSuccesBackground = '--toastSuccesBackground',
    toastError = '--toastError',
    toastErrorBackground = '--toastErrorBackground',
    toastInfo = '--toastInfo',
    toastInfoBackground = '--toastInfoBackground',
    toastWarning = '--toastWarning',
    toastWarningBackground = '--toastWarningBackground',
}

export enum BaseColors {
    blue = '#5773BF',
    blueHighlight= "#CCD9FC",
    blueLight = '#E6ECFC',
    green = '#50AF89',
    greenLight = '#E7FFF5',
    red = '#943526',
    redLight = '#FFE7E3',
    yellow = '#FFF4B0',
    yellowLight = '#ffeace',
    white = '#FFF',
    black = '#3D3D3D',
    blackLight = '#00000029',
    grayDark = '#5B5B5B',
}


export enum DefaultColors {
    // Primary
    primary = BaseColors.blue,
    primaryButton = BaseColors.blue,

    // Secondary
    secondary = '#0097f5',

    // Font Color
    font = BaseColors.black,
    fontTitle = BaseColors.blue,
    dataHeader = BaseColors.grayDark,
    data = BaseColors.black,
    errorFont = BaseColors.red,
    inputPlaceHolderText = '#595959',
    instructionContainerFontColor = BaseColors.black,
    materialFont = BaseColors.grayDark,
    hyperLinkColor = '#0033FF',
    headerButtonFontColor = BaseColors.grayDark,
    formLabel = '#858585',
    devxlabelOne = '#50af89',
    devxlabelTwo = '#77c7a7',

    // Background
    background = BaseColors.white,
    inputBackground = BaseColors.white,
    errorBackground = BaseColors.redLight,
    loadingBackground = '#dedfe1',
    contentContainerBackground = '#F8F8F8',
    contentHeaderNoteBackground = BaseColors.blueLight, //TODO: update this name its used in multiple places 
    checkboxSelectedBackground = BaseColors.blue,
    checkboxUnselectedBackground = BaseColors.white,
    payStubTotalBackground = BaseColors.blue,
    materialFormDisabledbackground = '#E1E1E1',
    childTableRowBackground = '#E9EEF4',
    childTableBackground = '#ADADAD',
    headerFooterBackground = BaseColors.white,
    headerSeperator = '#EBEBEB',
    headerBoxShadow = BaseColors.blackLight,
    subHeaderBackground = '#ECFAFF',


    // Button
    buttonMenuLinkHovered = '#4473B8',
    buttonRegisterFontReg = BaseColors.blue,
    buttonRegisterFontHovered = BaseColors.blue,
    buttonRegisterHovered = BaseColors.blueHighlight,
    buttonPrimaryFontReg = BaseColors.white,
    buttonPrimaryFontHovered = BaseColors.white,
    buttonPrimaryFontActive = BaseColors.white,
    buttonPrimaryFontDisabled = BaseColors.white,
    buttonPrimaryBackgroundReg = BaseColors.blue,
    buttonPrimaryBackgroundHovered = '#122C53',
    buttonPrimaryBackgroundActive = '#112440',
    buttonPrimaryBackgroundDisabled = '#949494',
    buttonSecondaryFontReg = BaseColors.blue,
    buttonSecondaryFontHovered = BaseColors.blue,
    buttonSecondaryFontActive = BaseColors.blue,
    buttonSecondaryFontDisabled = '#8F8F8F',
    buttonSecondaryBackgroundHovered = '#D5E5FF',
    buttonSecondaryBackgroundActive = BaseColors.blueHighlight,


    // Other
    border = '#858585',
    radioButtonUnselected = BaseColors.black,
    radioButtonSelected = BaseColors.blue,
    toggleButtonSelected = BaseColors.blue,
    materialFieldBorder = '#919191',
    appDividerContainer = BaseColors.white,
    materialFormDisabledFont = '#595959',
    materialFormDisabledBorder = '#919191',
    tableBorder = '#B3B5B8',
    footerBorderColor = BaseColors.blue,
    dropdownIcon = BaseColors.grayDark,
    selectionContentActive = BaseColors.blue,


    // New Controls
    newControlEnabledBackground = BaseColors.white,
    newControlEnabledBorder = '#858585',
    newControlEnabledUnselected = BaseColors.white,
    newControlEnabledSelected = BaseColors.blue,
    newControlDisabledBackground = '#D1D1D1',
    newControlDisabledBorder = '#5A6273',
    newControlDisabledUnselected = '#D1D1D1',
    newControlDisabledSelected = '#5A6273',


    // Toastr
    toastSucces = BaseColors.green,
    toastSuccesBackground = BaseColors.greenLight,
    toastError = BaseColors.red,
    toastErrorBackground = BaseColors.redLight,
    toastInfo = BaseColors.blue,
    toastInfoBackground = BaseColors.blueLight,
    toastWarning = BaseColors.yellow,
    toastWarningBackground = BaseColors.yellowLight,

    //In Page NavBar Icon Backgrounds
    navBarIconBlue = '#9BB6FF',
    navBarIconMint = '#9BFFD1',
    navBarIconCoral = '#FFA89B',
    navBarIconCyan = '#9BFFFF',
    navBarIconLavender = '#B99BFF',
    navBarIconPeach = '#FFDE9B',
    navBarIconGray = '#C9C9C9',



    // Misc / Legacy (not in ColorVariable)
    transparentButtonText = BaseColors.blue,
    transparentButtonHovered = BaseColors.black,
    langaugeToggleSelectedFont = BaseColors.white,
    languageToggleUnselectedFont = '#595959',
}

export const defaultBackgroundColor = DefaultColors.background;